import * as React from 'react'
import { CellContext } from '@tanstack/react-table'
import { Team } from 'store/modules/teams'
import { AvatarButtonGroup, Link } from 'src/design-system'
import { avatarGroupProps } from 'app/packs/src/utils/user-helpers'

export const MembersCell = (data: CellContext<Team, unknown>) => {
  const members = data.cell.row.original?.users
  const team = data.cell.row.original

  return (
    <div className="flex flex-row gap-x-1 justify-start items-center">
      <Link href={`${team.baseUrl}/members`} underline={false}>
        <span className="sr-only">Manage team members</span>
        <AvatarButtonGroup
          avatars={avatarGroupProps(members, {
            href: false,
            stateTooltip: false,
          })}
          className="mr-1 text-gray-500"
          size="xs"
          limitStyle="tag"
          limit={4}
          showEmptyState={true}
        />
      </Link>
    </div>
  )
}
